import React, { useState } from "react";
import { User, Lock, ArrowRight, ShieldCheck } from "lucide-react";

export default function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState("admin@company.com");
  const [password, setPassword] = useState("password123");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulated backend check: Future-proofed for both Admin and Employee roles
    setTimeout(() => {
      let loggedInUser;

      // 1. Default review fallback rule for your current presentation
      if (email.includes("admin") || email === "admin@company.com") {
        loggedInUser = {
          full_name: "Rahul Sharma",
          official_email: email,
          role: "Admin",
          status: "active",
        };
      } else {
        // 2. Future dynamic employee login structure (fetches individual user view)
        loggedInUser = {
          full_name: email.split("@")[0].replace(".", " "),
          official_email: email,
          role: "Employee",
          status: "active",
        };
      }

      // Secure session token handling
      localStorage.setItem("token", "dynamic-auth-token-xyz");
      localStorage.setItem("user", JSON.stringify(loggedInUser));

      setIsLoading(false);
      if (onLoginSuccess) onLoginSuccess(loggedInUser);
      else window.location.reload();
    }, 600);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md rounded-3xl shadow-2xl p-8 border border-slate-100 animate-in fade-in zoom-in-95 duration-300">
        <div className="flex flex-col items-center text-center mb-8">
          <div className="w-14 h-14 bg-blue-600 rounded-2xl flex items-center justify-center text-white font-bold text-2xl shadow-lg shadow-blue-500/30 mb-4">
            A
          </div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
            Employee Module
          </h1>
          <p className="text-xs text-slate-500 mt-1">
            Sign in with your admin or employee credentials
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-[11px] font-bold text-slate-700 uppercase tracking-wider mb-1.5">
              Email Address
            </label>
            <div className="relative flex items-center">
              <User className="absolute left-3.5 w-4 h-4 text-slate-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@company.com or employee email"
                className="w-full bg-slate-50 border border-slate-200 rounded-xl py-3 pl-10 pr-4 text-xs font-medium text-slate-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-600 transition-all"
              />
            </div>
          </div>

          <div>
            <label className="block text-[11px] font-bold text-slate-700 uppercase tracking-wider mb-1.5">
              Password
            </label>
            <div className="relative flex items-center">
              <Lock className="absolute left-3.5 w-4 h-4 text-slate-400" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full bg-slate-50 border border-slate-200 rounded-xl py-3 pl-10 pr-4 text-xs font-medium text-slate-900 focus:outline-none focus:bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-600 transition-all"
              />
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 flex items-start gap-2.5 text-[11px] text-blue-700 mt-2">
            <ShieldCheck className="w-4 h-4 shrink-0 mt-0.5 text-blue-600" />
            <span>
              <strong>Review Mode Active:</strong> Defaults to Admin view.
              Supports dynamic routing for both admin & individual employee
              logins.
            </span>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full mt-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3.5 rounded-xl text-xs shadow-lg shadow-blue-600/25 transition-all flex items-center justify-center gap-2 disabled:opacity-50 cursor-pointer"
          >
            {isLoading ? "Authenticating..." : "Sign In"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
